import regeneratorRuntime from "regenerator-runtime";
import Sortable from "sortablejs";

export default class ListingEditor {
  constructor() {
    this.delta = {
      productions: {
        add: [],
        remove: {}
      },
      awards: {
        add: [],
        remove: {}
      }
    }
  }
  attachEditor(genres, productions, addProductions, awards, addAwards, updateButton, hideProfile, hideAddress, images) {
    // Attach Delete buttons
    productions.querySelectorAll('[data-idx]').forEach((element) => {
      const deleteButton = element.querySelector('button')
      deleteButton.addEventListener('click', event => {
        event.preventDefault();
        this.delta.productions.remove[element.dataset.idx] = {
          node: element
        }
        element.remove()
        console.log({ delta: this.delta })
      })
    })
    
    // Attach add productions
    addProductions.querySelector('button').addEventListener('click', (event) => {
      event.preventDefault;

      const data = {
        release: addProductions.querySelector('[name="release"]').value,
        title: addProductions.querySelector('[name="title"]').value,
        genre: addProductions.querySelector('[name="genre"]').value
      }

      // Only react to the click if the form has data in it that makes sense
      if ((data.release.length < 1) || (data.title.length < 3) || (data.release.genre < 1)) {
        return
      }

      this.delta.productions.add.push(data)
      const idx = this.findIdx(productions)

      const html = new DOMParser().parseFromString(`
      <div class="form_production-item" data-idx="${idx}">
        <div>${data.release}</div><div>${data.title}</div><div>${data.genre}</div><button> Delete </button>
      </div>`, 'text/html')
      const newEntry = html.body.firstChild
      newEntry.querySelector('button').addEventListener('click', event => {
        event.preventDefault()
        this.delta.productions.add = this.delta.productions.add.filter(item => item !== data)
        newEntry.remove()
        console.log(this.delta)
      })
      productions.appendChild(html.body.firstChild)
      
      // Reset the fields
      addProductions.querySelector('[name="release"]').selectedIndex = 0
      addProductions.querySelector('[name="genre"]').selectedIndex = 0
      addProductions.querySelector('[name="title"]').value = ''
    })

    // Attach add awards
    awards.querySelectorAll('[data-idx]').forEach((element) => {
      const deleteButton = element.querySelector('button')
      deleteButton.addEventListener('click', event => {
        event.preventDefault();
        this.delta.awards.remove[element.dataset.idx] = {
          node: element
        }
        element.remove()
        console.log({
          delta: this.delta
        })
      })
    })

    // Attach image deletion
    images.querySelectorAll('.image-file').forEach(image => {
      image.querySelector('.delete-image').addEventListener('click', async (ev) => {
        ev.preventDefault()
        const response = await fetch(
            '/dashboard/directory/images',
            { method: 'DELETE', body: { image: image.dataset.image }})
        image.remove()
        this.updateImageSorting(images, document.getElementById('image-order'))
      })
    })

    // Attach image drag and drop sorting
    const sortable = Sortable.create(
        images,
        {
          handle: '.drag-marker',
          onEnd: () => { this.updateImageSorting(images, document.getElementById('image-order'))}
        }
    );

    // Attach add productions
    addAwards.querySelector('button').addEventListener('click', (event) => {
      event.preventDefault;

      const data = {
        award: addAwards.querySelector('[name="award"]').value,
        production: addAwards.querySelector('[name="production"]').value,
        year: addAwards.querySelector('[name="year"]').value
      }

      // Only react to the click if the form has data in it that makes sense
      if ((data.award.length < 3) || (data.production.length < 3) || (data.year.length < 1)) {
        return
      }

      this.delta.awards.add.push(data)
      const idx = this.findIdx(awards)

      const html = new DOMParser().parseFromString(`
      <div class="form_production-item" data-idx="${idx}">
        <div>${data.year}</div><div>${data.production}</div><div>${data.award}</div><button> Delete </button>
      </div>`, 'text/html')
      const newEntry = html.body.firstChild
      newEntry.querySelector('button').addEventListener('click', event => {
        event.preventDefault()
        this.delta.awards.add = this.delta.awards.add.filter(item => item !== data)
        newEntry.remove()
        console.log(this.delta)
      })
      awards.appendChild(html.body.firstChild)

      // Reset the fields
      addAwards.querySelector('[name="award"]').value = ''
      addAwards.querySelector('[name="production"]').value = ''
      addAwards.querySelector('[name="year"]').selectedIndex = 0
    })

    // Attach update action
    updateButton.addEventListener('click', async (event) => {
      event.preventDefault()
      await this.update(genres, hideProfile, hideAddress, document.getElementById('image-order'))
    })
  }

  async update(genres, hideProfile, hideAddress, imageOrder) {

    const response = fetch('/dashboard/directory', {
      method: 'POST',
      body: JSON.stringify({
        delta: this.delta,
        genres: this.collectGenres(genres),
        video: document.getElementById('video').value,
        hideProfile: hideProfile.checked ? 1 : 0,
        hideAddress: hideAddress.checked ? 1 : 0,
        imageOrder: imageOrder.value
      })
    })

    // Reset changes
    this.delta = {
      productions: {
        add: [],
        remove: {}
      },
      awards: {
        add: {},
        remove: {}
      }
    }

    if (!response.ok) {
      return false
    }
    return true
  }

  updateImageSorting(images, field) {
    let all = []
    for (const image of images.children) {
      all.push(encodeURIComponent(image.dataset.id))
    }
    field.value = all.join('|')
  }

  findIdx(parent) {
    let result = 0
    parent.querySelectorAll('[data-idx]').forEach((element) => {
      if (element.dataset.idx > result) {
        result = element.dataset.idx
      }
    })

    return result
  }

  collectGenres(genres) {
    const selectedGenres = [];
    genres.forEach((input) => {
      if (input.checked) {
        selectedGenres.push(input.name);
      }
    });
    return selectedGenres
  }
}
